// import { apiGet, apiPost, apiPatch } from './index'
import { apiGet, apiPost } from './index'
const getCodeByMobile = (params) => apiGet('/api/sendcode/mobile', params)
const bindMobile = (params) => apiPost('/auth/auth/bind', params)
const getInvUser = (params) => apiGet('/api/Center/userinfoBycode', params)
const getAddressList = (params) => apiGet('/api/Address/lists', params)
const getCityTree = (params) => apiGet('/api/Address/getCityTree', params)
const getProvice = (params) => apiGet('/api/Address/getLinkage', params)
const saveAddress = (params) => apiPost('/api/Address/save', params)
const delAddress = (params) => apiGet('/api/Address/del', params)
const getAddress = (params) => apiGet('/api/Address/info', params)
const getDefaultAddress = (params) => apiGet('/api/Address/getDefault', params)

export {
  getCodeByMobile,
  bindMobile,
  getInvUser,
  getAddressList,
  getCityTree,
  getProvice,
  saveAddress,
  delAddress,
  getAddress,
  getDefaultAddress
}



// WEBPACK FOOTER //
// ./src/api/bind.js